import { UserListItemDto } from '../config/userConfig'
import useGlobalContext from './useGlobalContext'

export type UsersProps = {
    loaded: boolean
    users: UserListItemDto[]
    getUserById: (id: string) => UserListItemDto
    getUserByEmail: (email: string) => UserListItemDto
}

export default function useUsers(): UsersProps {
    const { entities, loaded } = useGlobalContext('users')

    const getUserById: UsersProps['getUserById'] = (id: string): UserListItemDto =>
        entities.find(user => user.id === id)

    const getUserByEmail: UsersProps['getUserByEmail'] = (email: string): UserListItemDto =>
        entities.find(user => user.email === email)

    return { loaded, users: entities, getUserById, getUserByEmail }
}
